import React , {useState} from 'react'
import { VStack, Input, Button } from '@chakra-ui/react'
import { FormControl, FormLabel } from '@chakra-ui/form-control'
import { InputGroup, InputRightElement } from "@chakra-ui/input";
import { useToast } from "@chakra-ui/toast";
import axios from 'axios';
import {useHistory} from 'react-router-dom'
import EnvRoute from '../../middleware/envRoute';
const ENDPOINT = EnvRoute('prod'); 


const Signup  = () => {
  const [ preferredName , setPreferredName ] = useState()
  const [ email , setEmail ] = useState()
  const [ phone, setPhone ] = useState()
  const [ password , setPassword ] = useState()
  const [ confirmPassword , setConfirmPassword ] = useState()
  const [ pic , setPic ] = useState()
  const [ isOnline , setIsOnline ] = useState(true)

  const [ picLoading , setPicLoading ] = useState(false)
  const [ show , setShow ] = useState(false)
  const history = useHistory()

  const handleClicK = () => {setShow(!show)}

  const toast = useToast();

//  =================
//  + SubmitHandler

//  =================
  const submitHandler = async () => {
    setPicLoading(true);
    if (!preferredName || !email || !password || !confirmPassword || !phone) {
      toast({
        title: "Please Fill all the Feilds",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setPicLoading(false);
      return;
    }
    if (password !== confirmPassword) {
      toast({
        title: "Passwords Do Not Match",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setPicLoading(false);
      return;
    }
    console.log(preferredName, email, password, pic, phone);
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };
      setIsOnline(true)
      const { data } = await axios.post(
        `${ENDPOINT}/api/user`,
        {
          preferredName,
          email,
          phone,
          password,
          pic,
          isOnline,
        },
        config
      );
      console.log(data);
      toast({
        title: "Registration Successful",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      localStorage.setItem("userInfo", JSON.stringify(data));
      setPicLoading(false);
      history.push("/chats");

    } catch (error) {
      toast({
        title: "Error Occured!",
        description: error.response.data.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setPicLoading(false);
    }
  };
//  =================
//  + Post Details

//  =================
  const postDetails = (pics) => {
    setPicLoading(true);
    if (pics === undefined) {
      toast({
        title: "Please Select an Image!",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      return;
    } 
  
  if (pics.type === "image/jpeg" || pics.type === "image/png" || pics.type === "image/gif") {
      const data = new FormData();
      data.append("file", pics);
      data.append("upload_preset", "TinCan");
      data.append("cloud_name", "dzxzdsnha");
      fetch("https://api.cloudinary.com/v1_1/dzxzdsnha/upload", {
        method: "post",
        body: data,
      })
        .then((res) => res.json())
        .then((data) => {
          setPic(data.url.toString());
          console.log(data.url.toString());
          setPicLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setPicLoading(false);
        });
    } else {
      toast({
        title: "Please Select an Image!",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setPicLoading(false);
      return;
    }
  }
  
  return (
    <VStack spacing ='5px'>

      <FormControl id ="first-name" isrequired>
        <FormLabel>name</FormLabel>
          <Input  
            placeholder='enter your username'
            onChange={(e)=>setPreferredName(e.target.value)}
            border={'1px solid #868686'}
              color={'#868686'}
            />
      </FormControl>

      <FormControl id ="email" isrequired>
        <FormLabel>email</FormLabel>
          <Input  
            placeholder='enter email'
            onChange={(e)=>setEmail(e.target.value.toLowerCase())}
            border={'1px solid #868686'}
              color={'#868686'}
            />
      </FormControl>

      <FormControl id ="phone" isrequired>
        <FormLabel>phone</FormLabel>
          <Input  
          type={'phone'}
            placeholder='enter phone number'
            onChange={(e)=>setPhone(e.target.value)}
            border={'1px solid #868686'}
              color={'#868686'}
            />
      </FormControl>

      <FormControl id ="password" isrequired>
        <FormLabel>password</FormLabel>
        
        <InputGroup>
            <Input  
            type={show ?'text':'password'}
              placeholder='enter password'
              onChange={(e)=>setPassword(e.target.value)}
              border={'1px solid #868686'}
              color={'#868686'}
              />
        <InputRightElement width="4.5rem">
            <Button h="1.75rem" size="sm" onClick={handleClicK}>
              {show ? "hide" : "show"}
            </Button>
        </InputRightElement>
        </InputGroup>
      </FormControl>

      <FormControl id ="password" isrequired>
        <FormLabel>confirm password</FormLabel>
        
        <InputGroup>
            <Input  
            type={show ?'text':'password'}
              placeholder='enter password'
              onChange={(e)=>setConfirmPassword(e.target.value)}
              border={'1px solid #868686'}
              color={'#868686'}
              />
        <InputRightElement width="4.5rem">
            <Button h="1.75rem" size="sm" onClick={handleClicK}>
              {show ? "hide" : "show"}
            </Button>
        </InputRightElement>
        </InputGroup>
      </FormControl>

      <FormControl id ="pic" isrequired>
        <FormLabel>upload pic</FormLabel>
        <Input 
        type="file"
        p={1.5}
        accept ="image/*"
        onChange={(e) => postDetails(e.target.files[0])}
        border={'1px solid #868686'}
        color={'#868686'}
        />
      </FormControl>
       <Button
        colorScheme="blue"
        width="100%"
        style={{ marginTop: 15 }}
        onClick={submitHandler}
        isLoading={picLoading}
      >
        Sign Up
      </Button>
    </VStack>
  )
}

export default Signup